const pl = {
  site: {
    name: "USFans Spreadsheet",
    tagline: "Kompletny system zarządzania danymi twórców",
  },
  nav: {
    categories: "Kategorie produktów",
    home: "Strona główna",
    guide: "Przewodnik",
    buyNow: "buy it now",
    usfans: "usfans spreadsheet",
    shoppingGuide: "Przewodnik zakupów",
  },
  hero: {
    title: "Najlepszy USFans Spreadsheet dla twórców w 2026 roku",
    subtitle: "Porównania, szablony, poradniki i narzędzia pomagające organizować dane, przychody i treści szybciej oraz bezpieczniej.",
    ctaGuide: "Sprawdź przewodnik",
    ctaTemplate: "Pobierz szablon",
    ctaCompare: "Zobacz porównanie",
  },
  trust: {
    updated: "Aktualizowane w 2026",
    secure: "Bezpieczne rozwiązania",
    free: "Darmowe poradniki",
    gdpr: "Dane chronione zgodnie z GDPR",
  },
  stats: {
    visits: "odwiedzin",
    guides: "poradników",
    free: "darmowe materiały",
    title: "USFans Spreadsheet — Kompletny system zarządzania",
  },
  features: {
    tag: "Narzędzia",
    title: "Jak USFans Spreadsheet pomaga zarządzać danymi?",
    subtitle: "Odkryj kluczowe funkcje, które ułatwiają organizację danych, śledzenie wyników i automatyzację procesów twórczych.",
  },
  problem: {
    title: "Dlaczego twórcy potrzebują USFans Spreadsheet?",
    items: [
      "Chaos danych — brak jednego miejsca na wszystkie informacje",
      "Brak organizacji — trudności w śledzeniu postępów i wyników",
      "Utrata informacji — rozproszone dane w różnych miejscach",
      "Trudność śledzenia wyników — brak jasnego obrazu efektywności",
    ],
  },
  comparison: {
    title: "USFans Spreadsheet vs Excel vs Notion",
    features: ["Organizacja", "Śledzenie danych", "Automatyzacja", "Łatwość użycia", "Bezpieczeństwo"],
  },
  products: {
    title1: "Przeglądaj",
    title2: "kategorie produktów",
    description: "Odkryj szeroką gamę produktów dostępnych w naszym sklepie. Każda kategoria oferuje starannie wyselekcjonowane produkty dla twórców i entuzjastów.",
    viewAll: "Zobacz wszystkie produkty",
  },
  article: {
    tag: "Przewodnik",
    title: "USFans Spreadsheet — Kompletny przewodnik 2026",
    summary: "USFans Spreadsheet to zaawansowane narzędzie do zarządzania danymi stworzone specjalnie dla twórców. W tym przewodniku znajdziesz wszystko, co musisz wiedzieć — od podstawowych funkcji po zaawansowane techniki organizacji danych. Dowiesz się, jak efektywnie korzystać z szablonów, śledzić postępy i automatyzować codzienne zadania.",
    readMore: "Przeczytaj przewodnik",
    updated: "Aktualizacja: Czerwiec 2026",
    verified: "Treść została sprawdzona przez redakcję.",
  },
  testimonials: {
    tag: "Opinie",
    title: "Opinie twórców",
  },
  cta: {
    title: "BUY IT NOW",
    subtitle1: "Gotowy, aby zorganizować swoje dane?",
    subtitle2: "Dołącz do tysięcy zadowolonych twórców.",
    button: "USFANS SPREADSHEET",
  },
  footer: {
    rights: "© USFans Spreadsheet 2026. Wszelkie prawa zastrzeżone.",
    description: "USFans Spreadsheet to kompletny system zarządzania danymi dla twórców. Organizuj, śledź i rozwijaj swoje projekty.",
    newsletter: "Zapisz się do newslettera",
    newsletterDesc: "Otrzymuj najnowsze poradniki i aktualizacje.",
    subscribe: "Zapisz się",
    emailPlaceholder: "Twój adres email",
    quickLinks: "Szybkie linki",
    categories_footer: "Kategorie",
    resources: "Zasoby",
    motto: "Organizuj. Twórz. Rosnij.",
  },
  faq: {
    title: "Często zadawane pytania",
  },
  breadcrumb: {
    home: "Strona główna",
  },
};

export default pl;